export class CustomerInfo {
    FirstName: string | null;
    LastName: string | null;
    Email: string | null;
    PhoneNumber: string | null;

    constructor() {}
}
